export default function (context, value) {
    context.dispatch('settings/open', 'regulars', {root: true});
}